<header class="container-fluid">
	<div class="texto-environment" *ngIf="environmentPrefix != 'prod'">
        <div translate>header.{{environmentPrefix}}</div>
    </div>
    <div class="row logos">
    	<div class="logoInstituicional"><img src="assets/images/logoInstitucional.png" alt="Logo institucional"></div>
        <div class="col"></div>
        <div class="logoB2B"><img src="assets/images/logoB2B.png" alt="Logo FACeB2B"></div>

    </div>
</header>



// WEBPACK FOOTER //
// ./src/app/app-public/pub-header/pub-header.component.html